var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("@/assets/public/developing.png"),"mode":"","width":"240","height":"240"}}),_c('div',{staticClass:"yx-color-info fz-16"},[_vm._v("功能正在开发中，敬请期待...")])])
}]

export { render, staticRenderFns }